@if (showApp) {
  <router-outlet/>
} @else {
  <div class="splash" *ngIf="growUpImage">
    <img src="assets/image/svg/mar-logo-white.svg" alt="Logo">
  </div>
}


